import React, { useCallback, useContext } from 'react';
import { useTooltip } from '@vx/tooltip';

import { isDocumentAvailable } from '../utils/browserObjectsAvailability';
import { REPORT_CONTENT_ID } from '../utils/constants';

const getReportContent = () => isDocumentAvailable() && document.querySelector(`#${REPORT_CONTENT_ID}`);

const ChartTooltipContext = React.createContext({});

export const ChartTooltipContextProvider = ({ children }) => {
  const { tooltipData, tooltipLeft, tooltipTop, tooltipOpen, hideTooltip, showTooltip } = useTooltip();

  let hide;

  hide = useCallback(() => {
    const reportContent = getReportContent();
    if (reportContent) reportContent.removeEventListener('scroll', hide);

    hideTooltip();
  });

  const show = useCallback(
    ({ data, top, left }) => {
      const reportContent = getReportContent();
      if (reportContent) reportContent.addEventListener('scroll', hide);

      showTooltip({
        tooltipData: data,
        tooltipTop: top,
        tooltipLeft: left,
      });
    },
    [tooltipOpen]
  );

  const bindHoverEvents = useCallback(
    (enterCallback) => ({
      onMouseLeave: () => hideTooltip(),
      onTouchStart: enterCallback,
      onTouchMove: enterCallback,
      onMouseMove: enterCallback,
    }),
    [hideTooltip]
  );

  return (
    <ChartTooltipContext.Provider
      value={{
        data: tooltipData,
        left: tooltipLeft,
        top: tooltipTop,
        isOpen: tooltipOpen,
        hide,
        show,
        bindHoverEvents,
      }}
    >
      {children}
    </ChartTooltipContext.Provider>
  );
};

export const useChartTooltipContext = () => {
  return useContext(ChartTooltipContext);
};
